var map = {
	"./1-option1-4row.png": 43,
	"./1-option10-4row.png": 44,
	"./1-option2-4row.png": 45,
	"./1-option3-4row.png": 46,
	"./1-option4-4row.png": 47,
	"./1-option5-4row.png": 48,
	"./1-option6-4row.png": 49,
	"./1-option7-4row.png": 50,
	"./1-option8-4row.png": 51,
	"./1-option9-4row.png": 52,
	"./1-placeholder.gif": 53,
	"./AwakenedDragon.png": 140,
	"./Jace-4row.png": 141,
	"./Jace.png": 142,
	"./LakeSprite.png": 143,
	"./Sara-4row.png": 144,
	"./Sara.png": 145,
	"./anna-4row.png": 146,
	"./anna.gif": 24,
	"./anna.png": 147,
	"./annaStanding.png": 148,
	"./caveFloor.png": 149,
	"./caveFloorTexture.png": 150,
	"./caveRock.png": 151,
	"./caveWallBottom.png": 152,
	"./caveWallCorner.png": 153,
	"./caveWallSide.png": 154,
	"./caveWallTop.png": 155,
	"./caveWalls.png": 156,
	"./child.png": 157,
	"./dragon-sleeping.svg": 158,
	"./erik-4row.png": 159,
	"./erik.gif": 28,
	"./erik.png": 160,
	"./forrestSpirit.png": 161,
	"./gladiator-4row.png": 162,
	"./gladiator.png": 163,
	"./gold.png": 164,
	"./goldPile.png": 165,
	"./goldPilePreview.png": 166,
	"./guardSoldier.png": 167,
	"./jace.gif": 25,
	"./king-4row.png": 168,
	"./king.png": 169,
	"./lake.png": 170,
	"./mountainCave.png": 171,
	"./npc-female-4row.png": 172,
	"./npc-female.png": 173,
	"./option1-4row.png": 174,
	"./option1.png": 175,
	"./option10-4row.png": 176,
	"./option10.png": 177,
	"./option11-4row.png": 178,
	"./option11.png": 179,
	"./option2-4row.png": 180,
	"./option2.png": 181,
	"./option3-4row.png": 182,
	"./option3.png": 183,
	"./option4-4row.png": 184,
	"./option4.png": 185,
	"./option5-4row.png": 186,
	"./option5.png": 187,
	"./option6-4row.png": 188,
	"./option6.png": 189,
	"./option7-4row.png": 190,
	"./option7.png": 191,
	"./option8-4row.png": 192,
	"./option8.png": 193,
	"./option9-4row.png": 194,
	"./option9.png": 195,
	"./orcHiding.png": 196,
	"./rockWall.png": 197,
	"./rockWall1.png": 198,
	"./rockWallSheetBottom.png": 199,
	"./rockWallSheetCave.png": 200,
	"./rockWallSheetLeft.png": 201,
	"./rockWallSheetMiddle.png": 202,
	"./rockWallSheetRight.png": 203,
	"./rockWallSheetTop.png": 204,
	"./sleepyDragon.png": 205,
	"./sleepyDragonFrame1.png": 206,
	"./sleepyDragonFrame2.png": 207,
	"./sleepyDragonFrame3.png": 208,
	"./sleepyDragonFrame4.png": 209,
	"./sleepyDragonz.png": 210,
	"./sleepyDragonzFrame1.png": 211,
	"./sleepyDragonzFrame2.png": 212,
	"./sleepyDragonzFrame3.png": 213,
	"./sleepyDragonzFrame4.png": 214,
	"./sleepyDragonzFrame5.png": 215,
	"./sleepyDragonzFrame6.png": 216,
	"./sleepyDragonzFrame7.png": 217,
	"./sleepyDragonzFrame8.png": 218,
	"./soldier.png": 219,
	"./tony-4row.png": 220,
	"./tony.gif": 27,
	"./tony.png": 221,
	"./tree.png": 222,
	"./villager.png": 223,
	"./vinnie-4row.png": 224,
	"./vinnie.gif": 26,
	"./vinnie.png": 225,
	"./wilson.gif": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 139;